import CollectionService from '@boServices/collectionService';
import { useCallback, useEffect, useState } from 'react';

const collectionService = new CollectionService();

// Collection shown by the detail page. `setCollection` replaces it after a save, or takes a function of the shown
// collection that returns the new one, as a state setter does. Once another collection is shown, it does nothing.
const useCollection = (id) => {
    // Last answer, tagged with its id: while another collection loads, nothing of the previous one is exposed.
    const [loaded, setLoaded] = useState({ id: null, collection: null, error: null });

    useEffect(() => {
        // A late answer for a previous id must not overwrite the current collection.
        let cancelled = false;
        collectionService
            .getCollection(id)
            .then((collection) => {
                if (!cancelled) setLoaded({ id, collection, error: null });
            })
            .catch((error) => {
                if (!cancelled) setLoaded({ id, collection: null, error });
            });
        return () => {
            cancelled = true;
        };
    }, [id]);

    const setCollection = useCallback(
        (next) =>
            setLoaded((current) => {
                if (current.id !== id) return current;
                return { id, collection: typeof next === 'function' ? next(current.collection) : next, error: null };
            }),
        [id],
    );

    const isLoaded = loaded.id === id;

    return {
        collection: isLoaded ? loaded.collection : null,
        loading: !isLoaded,
        error: isLoaded ? loaded.error : null,
        setCollection,
    };
};

export default useCollection;
